import { createActionGroup, emptyProps, props } from '@ngrx/store';

/**
 * Cart intents carry the product's `stock` and `name` so the reducer can
 * clamp purely (0..stock) and effects can give feedback — no cross-slice
 * lookups needed inside the reducer.
 */
export const CartActions = createActionGroup({
  source: 'Cart',
  events: {
    'Add To Cart': props<{ productId: string; delta: number; stock: number; name: string }>(),
    'Set Qty': props<{ productId: string; raw: string; stock: number; name: string }>(),
    'Remove From Cart': props<{ productId: string; name: string }>(),
    'Clear Cart': emptyProps(),
  },
});
